export const FORMAT_SD_CARD_OPEN_MODAL = "FORMAT_SD_CARD_OPEN_MODAL";
export const FORMAT_SD_CARD_CLOSE_MODAL = "FORMAT_SD_CARD_CLOSE_MODAL";

export const FORMAT_SD_CARD_REQUEST = "FORMAT_SD_CARD_REQUEST";
export const FORMAT_SD_CARD_RESULT = "FORMAT_SD_CARD_RESULT";